export enum LicenseViewType {
  Invoices,
  Reports,
  Grouped,
}
